import React from 'react';
import PropTypes from 'prop-types';
import Head from 'components/head';
import { StaticQuery, graphql } from 'gatsby';
import GlobalStyle from 'global.css.js';
import { Wrapper } from './layout.css';

const Layout = ({ children }) => (
  <div>
    <GlobalStyle />
    <Head />
    <Wrapper>{children}</Wrapper>
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

const LayoutWithQuery = props => (
  <StaticQuery
    query={graphql`
      query LayoutQuery {
        site {
          siteMetadata {
            siteTitle
          }
        }
      }
    `}
    render={data => <Layout data={data} {...props} />}
  />
);

LayoutWithQuery.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutWithQuery;
